<script>
    import Image from "./Image.svelte";
    import Button from "./Button.svelte";
    import TextEditor from "../../Common/TextEditor.svelte";
    import {getStyleValue} from "../../Common/tools";

    export let data, meta, globalStyle, onChange;

    function change(val) {
      onChange();
      data = Object.assign({}, data, {content: val});
    }
</script>
<tr>
    <th>
        <table>
            <tbody>
            <tr>
              {#if data.switched}
                  <th class="column mobile-12" style="padding-right: 40px; padding-left: 40px;"
                      width="{getStyleValue(globalStyle.width, 600)*0.5}">
                      <table cellspacing="0" cellpadding="0">
                          <tbody>
                          <tr><td class="spacer" height="20" style="font-size: 20px; line-height: 20px; height: 20px;">&nbsp;</td></tr>
                          <tr>
                              <th style="color: #969AA1; font-weight: 400; text-align: left;">
                                  <TextEditor data={data.content} meta={meta} onChange={change} emailEditor={true} />
                                  <Button bind:data={data} meta={meta} globalStyle={globalStyle} isChild={true} onChange={onChange}/>
                              </th>
                          </tr>
                          <tr><td class="spacer" height="20" style="font-size: 20px; line-height: 20px; height: 20px;">&nbsp;</td></tr>
                          </tbody>

                      </table>
                  </th>
                  <th class="column mobile-12" style="text-align: left; line-height: 0;"
                      width="{getStyleValue(globalStyle.width, 600)*0.5}">
                      <table cellspacing="0" cellpadding="0" class="component-right">
                          <tbody>
                          <tr>
                              <Image data={data} globalStyle={globalStyle} placeholderSize="310x300" isChild={true}/>
                          </tr>
                          </tbody>
                      </table>
                  </th>
              {:else}
                  <th class="column mobile-12" style="text-align: left; line-height: 0;"
                      width="{getStyleValue(globalStyle.width, 600)*0.5}">
                      <table cellspacing="0" cellpadding="0">
                          <tbody>
                          <tr>
                              <Image data={data} globalStyle={globalStyle} placeholderSize="310x300" isChild={true}/>
                          </tr>
                          </tbody>
                      </table>
                  </th>
                  <th class="column mobile-12" style="padding-right: 40px; padding-left: 40px;"
                      width="{getStyleValue(globalStyle.width, 600)*0.5}">
                      <table cellspacing="0" cellpadding="0">
                          <tbody>
                          <tr><td class="spacer" height="20" style="font-size: 20px; line-height: 20px; height: 20px;">&nbsp;</td></tr>
                          <tr>
                              <th style="color: #969AA1; font-weight: 400; text-align: left;">
                                  <TextEditor data={data.content} meta={meta} onChange={change} emailEditor={true} />
                                  <Button bind:data={data} meta={meta} globalStyle={globalStyle} isChild={true} onChange={onChange}/>
                              </th>
                          </tr>
                          <tr><td class="spacer" height="20" style="font-size: 20px; line-height: 20px; height: 20px;">&nbsp;</td></tr>
                          </tbody>
                      </table>
                  </th>
              {/if}

            </tr>
            </tbody>
        </table>
    </th>
</tr>
